import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  Button,
  Divider,
  CardActions,
  CardContent,
  Typography,
  makeStyles, Box
} from '@material-ui/core';
import { QuestionAnswer, Sort as SortIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 297.5,
    height: 115,
  }
}));

const BannerCardPreview = forwardRef(({
  className, banner, onUpload, hasImage, ...rest
}, ref) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    ref?.current?.addEventListener('change', () => {
      setPreviewImage(URL.createObjectURL(ref?.current?.files[0]));
    });
  }, []);

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="banner"
              src={previewImage || banner?.image}
              variant="square"
            />
          </Grid>
        </Grid>
      </CardContent>
      <>
        <Divider />
        <Box p={2}>
          <Grid item container justify="flex-end" alignItems="center">
            <Typography color="textPrimary" variant="h4" align="right">
              {banner?.description}
            </Typography>
          </Grid>
        </Box>
      </>
      <>
        <Divider />
        <Box p={2}>
          <Grid item container alignItems="center">
            <Box mr={1}>
              <SortIcon color="action" />
            </Box>
            <Typography color="textSecondary" display="inline" variant="body2" align="left">
              Orden
              {': '}
              {banner?.order || 0}
            </Typography>
          </Grid>
          <Grid item container alignItems="center">
            <Box mr={1}>
              <QuestionAnswer color="action" />
            </Box>
            <Typography color="textSecondary" display="inline" variant="body2" align="left">
              Disponible
              {': '}
              {banner?.is_available ? 'Si' : 'No' }
            </Typography>
          </Grid>
        </Box>
      </>
      {
        !hasImage && (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                onClick={onUpload}
              >
                Subir Imagen
              </Button>
            </CardActions>
          </>
        )
      }
    </Card>
  );
});

BannerCardPreview.propTypes = {
  className: PropTypes.string,
  banner: PropTypes.object,
  hasImage: PropTypes.bool,
  onUpload: PropTypes.func,
};

BannerCardPreview.defaultProps = {
  className: '',
  banner: {},
  hasImage: false,
  onUpload: () => {},
};

export default BannerCardPreview;
